/**
 * Travel Carbon Estimator
 * Copyright (C) 2026  Manuel Leduc
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { useLocalStorage } from '@vueuse/core'
import { watch } from 'vue'
import { useTheme } from 'vuetify'

export type ThemeMode = 'light' | 'dark'

const LIGHT_THEME = 'tceLight'
const DARK_THEME = 'tceDark'

export function useThemeMode() {
  const mode = useLocalStorage<ThemeMode>('tce-theme-mode', 'light')
  const theme = useTheme()

  watch(mode, (m) => theme.change(m === 'dark' ? DARK_THEME : LIGHT_THEME), { immediate: true })

  function toggle() {
    mode.value = mode.value === 'dark' ? 'light' : 'dark'
  }

  return { mode, toggle }
}
